"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getFieldDataState = function getFieldDataState(error) {
  return error ? "error" : "ok";
};

var _default = getFieldDataState;
exports.default = _default;